import { Helmet } from 'react-helmet-async';

const BASE = 'https://ainanan.kz';
const LANGS = ['ru', 'en', 'kz'];
// hreflang must use valid ISO codes; site uses "kz" in the URL but the language is Kazakh ("kk")
const HREFLANG = { ru: 'ru', en: 'en', kz: 'kk' };
const OG_LOCALE = { ru: 'ru_KZ', en: 'en_US', kz: 'kk_KZ' };
const DEFAULT_IMAGE = `${BASE}/logo.jpg`;

const buildUrl = (lang, path) => {
  const clean = (path || '').replace(/^\/+/, '');
  return `${BASE}/${lang}${clean ? '/' + clean : ''}`;
};

/**
 * Per-page SEO tags: unique title/description, canonical, hreflang alternates and Open Graph.
 * Pass localized strings via `title` / `description` (already resolved for the active language).
 */
export const Seo = ({ lang = 'ru', path = '', title, description, image, type = 'website', canonical }) => {
  const url = canonical || buildUrl(lang, path);
  return (
    <Helmet>
      <html lang={lang === 'kz' ? 'kk' : lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {!canonical && LANGS.map((l) => (
        <link key={l} rel="alternate" hrefLang={HREFLANG[l]} href={buildUrl(l, path)} />
      ))}
      {!canonical && <link rel="alternate" hrefLang="x-default" href={buildUrl('ru', path)} />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={OG_LOCALE[lang] || 'ru_KZ'} />
      <meta property="og:image" content={image || DEFAULT_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || DEFAULT_IMAGE} />
    </Helmet>
  );
};

export default Seo;
